import { RegisterForm } from "@/components"
import type { GetServerSideProps, NextPage } from 'next';
import { RegistrationLayout, ImageOnTheRightLayout } from '@/components';
import type { ReactElement } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { sm } from "src/site-map";
import PageMetaHead from "src/logic/config/meta/PageMetaHead";

export const getServerSideProps: GetServerSideProps = async context => {
    return {
        props: {
            email_invitation: context.query.email || null,
            company_id_invitation: context.query.company_id || null,
            company_name_invitation: context.query.company_name || null,
            company_country_invitation: context.query.company_country || null,
            company_state_invitation: context.query.company_state || null,
            company_city_invitation: context.query.company_city || null,
            company_industry_invitation: context.query.company_industry || null,
            company_address_invitation: context.query.company_address || null,
            company_fax_invitation: context.query.company_fax || null,
            company_trn_invitation: context.query.company_trn || null,
            company_work_number_invitation: context.query.company_work_number || null,
            invitation_id: context.query.invitation_id || null,
            ...(await serverSideTranslations(context.locale)),
        },
    };
};

type Props = {
    email_invitation?: string;
    company_id_invitation?: number;
    company_name_invitation?: string;
    company_country_invitation?: string;
    company_state_invitation?: string;
    company_city_invitation?: string;
    company_industry_invitation?: string;
    company_address_invitation?: string;
    company_fax_invitation?: number;
    company_trn_invitation?: number;
    company_work_number_invitation?: number;
    invitation_id?: string;
};
const Page: NextPage<Props> = (props: Props) => {
    return (
        <RegisterForm isBuyer
            emailInvitation={props.email_invitation}
            companyIdInvitation={props.company_id_invitation}
            companyNameInvitation={props.company_name_invitation}
            companyCountryInvitation={props.company_country_invitation}
            companyStateInvitation={props.company_state_invitation}
            companyCityInvitation={props.company_city_invitation}
            companyIndustryInvitation={props.company_industry_invitation}
            companyAddressInvitation={props.company_address_invitation}
            companyFaxInvitation={props.company_fax_invitation}
            companyTrnInvitation={props.company_trn_invitation}
            companyWorkNumberInvitation={props.company_work_number_invitation}
            invitationId={props.invitation_id}
        />
    )
}

Page.getLayout = function getLayout(page: ReactElement) {
    return (
        <RegistrationLayout>
            <PageMetaHead
                page_meta={{
                    title: 'Register as a Buyer | Access Verified Suppliers on eProcurement',
                    description:
                        'Register as a buyer and gain instant access to verified vendors, AI-driven tendering tools, and intelligent sourcing features all on one secure SaaS platform.',
                }}
                useExactTitle
            />
            <ImageOnTheRightLayout
                breadcrumbsAlias={sm.register.asBuyer.index.url}
                desktopImage={{
                    src: "/assets/images/sign-up/RegisterPhoto.png",
                    alt: ""
                }}>
                {page}
            </ImageOnTheRightLayout>
        </RegistrationLayout>
    )
}
export default Page